<div class="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-2 sm:gap-2.5 lg:gap-3">

  <div class="col-span-1" *ngFor="let staff of staffList">

    <div
      class="border border-[#D9D9D9] rounded-[8px] bg-white px-3 py-3
             flex items-center justify-between gap-3
             hover:shadow-md transition cursor-pointer"
      (click)="onRowClick(staff)"
    >

      <!-- LEFT: Avatar + Info -->
      <div class="flex items-center gap-3">

        <!-- Avatar -->
        <div class="size-16 bg-[#F9E698] rounded-md flex justify-center items-center shrink-0">
          <img
            class="size-11 object-cover rounded"
            [src]="staff?.profile || '/assets/images/user/user-profile.png'"
            alt="user profile"
          />
        </div>

        <!-- Info -->
        <div class="space-y-0.5 text-[#444]">
          <p class="text-sm lg:text-base font-semibold leading-tight">
            {{ staff.name }}
          </p>

          <p class="text-xs lg:text-sm text-gray-600">
            {{ staff.mobilenumber }}
          </p>

          <p class="text-[11px] lg:text-xs text-gray-500 truncate max-w-[180px]">
            {{ staff.email || '—' }}
          </p>
        </div>

      </div>

      <!-- RIGHT: Arrow -->
      <svg
        class="size-5 lg:size-6 text-gray-300"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>

    </div>

  </div>

  <!-- EMPTY STATE -->
  <div *ngIf="staffList.length === 0"
       class="col-span-full text-center py-10 text-gray-500">
    No staff found.
  </div>

</div>
